import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    fmDesc: {
        name: () => '描述',
    },

    fmName: {
        name: () => '功能域名称',
        required: () => true,
    },

    fmUserCode: {
        name: () => '功能域代码',
    },
})
